module.exports = "<dialog seedelement><div class=\"lui-overlay__content\"><slot></slot></div></dialog>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-overlay/theme/lui-overlay.html
// module id = 288
// module chunks = 0 1 28